var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EFF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5880_8627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5449 34.8509C20.1471 34.2802 20.7673 33.7395 21.4036 33.2288C32.8783 24.0191 49.5948 24.5598 60.454 34.8509",
    stroke: "#D5A34D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.318 41.84C46.4103 33.9322 33.5894 33.9322 25.6816 41.84",
    stroke: "#1E252D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.181 48.5028C43.6623 43.9841 36.3361 43.9841 31.8174 48.5028",
    stroke: "#1E252D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9992 56.3639C41.4113 56.3639 42.556 55.2191 42.556 53.8071C42.556 52.395 41.4113 51.2502 39.9992 51.2502C38.5871 51.2502 37.4424 52.395 37.4424 53.8071C37.4424 55.2191 38.5871 56.3639 39.9992 56.3639Z",
    fill: "#1E252D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5880_8627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.0909,
    height: 49.0909,
    fill: "white",
    transform: "translate(15.4541 15.4546)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiTip);
export default __webpack_public_path__ + "static/media/wifi_tip.73724124438e04a740778ea47c08f08d.svg";
export { ForwardRef as ReactComponent };